
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "27",
    "height": "27",
    "viewBox": "0 0 27 27"
  },
  "children": [
    {
      "tag": "defs",
      "children": [
        {
          "tag": "filter",
          "attrsMap": {
            "id": "4mr4lsq0qa"
          },
          "children": [
            {
              "tag": "feColorMatrix",
              "attrsMap": {
                "in": "SourceGraphic",
                "values": "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
              }
            }
          ]
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "fill": "none",
        "fill-rule": "evenodd"
      },
      "children": [
        {
          "tag": "g",
          "children": [
            {
              "tag": "g",
              "attrsMap": {
                "filter": "url(#4mr4lsq0qa)",
                "transform": "translate(-293 -714) translate(278 689)"
              },
              "children": [
                {
                  "tag": "g",
                  "attrsMap": {
                    "fill": "#000",
                    "fill-rule": "nonzero"
                  },
                  "children": [
                    {
                      "tag": "path",
                      "attrsMap": {
                        "d": "M13.5 27C6.045 27 0 20.955 0 13.5S6.045 0 13.5 0 27 6.045 27 13.5 20.955 27 13.5 27zm0-24.75C7.287 2.25 2.25 7.287 2.25 13.5S7.287 24.75 13.5 24.75s11.25-5.037 11.25-11.25S19.713 2.25 13.5 2.25zm-.924 12.188l-8.084-1.286 15.771-6.41L13.858 22.5l-1.282-8.06z",
                        "transform": "translate(15 25)"
                      }
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
})
    }
  